/**
 * ドロワーメニューの開閉機能
 */
export class Drawer {
  constructor() {
    this.drawer = document.getElementById('js-drawer')
    this.buttons = [...document.getElementsByClassName('js-drawer-button')]
    this.page = document.getElementById('page')

    if (!this.drawer || this.buttons.length === 0 || !this.page) return

    this.isOpen = false
    this.isAnimating = false

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (this.isAnimating) return
        this.toggle()
      })
    })

    document.addEventListener('click', (e) => {
      if (e.target.closest('#js-drawer') || e.target.closest('.js-drawer-button')) {
        return
      }
      this.hidden()
    })

    this.drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hidden()
      }
    })
  }

  visible() {
    if (this.isOpen || this.isAnimating) return
    this.isOpen = true
    this.isAnimating = true
    document.body.classList.add('is-drawer-open')
    this.drawer.classList.add('show-from')
    this.drawer.show()

    requestAnimationFrame(() => {
      this.drawer.classList.remove('show-from')
    })

    this.drawer.addEventListener(
      'transitionend',
      () => {
        this.isAnimating = false
      },
      { once: true },
    )
  }

  hidden() {
    if (!this.isOpen || this.isAnimating) return
    this.isOpen = false
    this.isAnimating = true
    document.body.classList.remove('is-drawer-open')
    this.drawer.classList.add('hide-to')

    const onTransitionEnd = (e) => {
      // if (e.target !== this.drawer) return
      this.drawer.removeEventListener('transitionend', onTransitionEnd)
      this.drawer.classList.remove('hide-to')
      this.drawer.close()
      this.isAnimating = false
    }

    this.drawer.addEventListener('transitionend', onTransitionEnd)
  }

  toggle() {
    if (this.isOpen) {
      this.hidden()
    } else {
      this.visible()
    }
  }
}
